// extracted by mini-css-extract-plugin
export var avatarContainer = "avatar-detail-module--avatar-container--7213f";
export var clientInfoContainer = "avatar-detail-module--client-info-container--7fc66";
export var detailsContainer = "avatar-detail-module--details-container--128a7";
export var subText = "avatar-detail-module--sub-text--e7013";